"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[940],{

/***/ 8940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Newsletter": function() { return /* binding */ Newsletter; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/lib/tracking/snowplow.ts
var tracking_snowplow = __webpack_require__(6713);
// EXTERNAL MODULE: ./src/lib/tracking/constants.ts
var constants = __webpack_require__(50);
// EXTERNAL MODULE: ./src/lib/tracking/googleTagManager.ts
var googleTagManager = __webpack_require__(4640);
// EXTERNAL MODULE: ./src/providers/StoryProvider.tsx
var StoryProvider = __webpack_require__(4727);
// EXTERNAL MODULE: ./src/utils/getSlugFromPath.ts
var getSlugFromPath = __webpack_require__(131);
;// CONCATENATED MODULE: ./src/blocks/utils/formFieldValidation.ts
var lengthIsGreaterThanZero = function(value) {
    return value.length > 0;
};
var isValidEmail = function(value) {
    var ref;
    // https://regexr.com/3e48o
    return !!((ref = value === null || value === void 0 ? void 0 : value.toLowerCase().match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)) === null || ref === void 0 ? void 0 : ref[0]);
};
var validateFormField = function(field) {
    var type = field.type, value = field.value;
    switch(type){
        case "email":
            return isValidEmail(value);
        default:
            return lengthIsGreaterThanZero(value);
    }
};
/* harmony default export */ var formFieldValidation = ((/* unused pure expression or super */ null && (validateFormField)));

// EXTERNAL MODULE: ./src/components/elements/InputText/InputText.tsx + 1 modules
var InputText = __webpack_require__(7445);
// EXTERNAL MODULE: ./src/components/elements/Button/Button.tsx
var Button = __webpack_require__(7539);
// EXTERNAL MODULE: ./src/components/elements/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(6764);
// EXTERNAL MODULE: ./src/components/elements/ExpandableLabel/ExpandableLabel.tsx + 1 modules
var ExpandableLabel = __webpack_require__(5887);
// EXTERNAL MODULE: ./public/icons/small/Mail.svg
var Mail = __webpack_require__(8126);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./src/components/elements/Alert/Alert.tsx + 2 modules
var Alert = __webpack_require__(5957);
// EXTERNAL MODULE: ./src/components/utils/mediaQueries.ts
var mediaQueries = __webpack_require__(5672);
// EXTERNAL MODULE: ./src/components/utils/gridCalc.ts
var gridCalc = __webpack_require__(3986);
// EXTERNAL MODULE: ./public/icons/large/Error.svg
var Error = __webpack_require__(1646);
// EXTERNAL MODULE: ./public/icons/large/House.svg
var House = __webpack_require__(3321);
// EXTERNAL MODULE: ./public/icons/large/Success.svg
var Success = __webpack_require__(3298);
// EXTERNAL MODULE: ./src/components/modules/Intro/Intro.tsx + 2 modules
var Intro = __webpack_require__(413);
// EXTERNAL MODULE: ./src/components/modules/RichText/RichText.tsx + 2 modules
var RichText = __webpack_require__(4070);
// EXTERNAL MODULE: ./src/components/modules/StatusScreen/StatusScreen.styled.ts + 1 modules
var StatusScreen_styled = __webpack_require__(1293);
// EXTERNAL MODULE: ./src/components/modules/Wrapper/Wrapper.tsx + 1 modules
var Wrapper = __webpack_require__(8709);
;// CONCATENATED MODULE: ./src/components/modules/Newsletter/Newsletter.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--color-newsletter-bg);\n  padding-top: var(--distance-dynamic-l);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: var(--distance-dynamic-xl);\n  padding-top: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: var(--distance-static-s);\n  text-align: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 0;\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: var(--distance-static-5xl);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 96px;\n  height: 96px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (",
        ") {\n    margin: 0 auto;\n    max-width: 545px;\n  }\n\n  @media screen and (",
        ") {\n    max-width: 664px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: var(--distance-static-s);\n  margin: 0 0\n    ",
        ";\n  border: none;\n  padding: 0;\n\n  @media screen and (",
        ") {\n    grid-template-columns: 1fr auto;\n    gap: var(--distance-static-l);\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin: 0 auto;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: var(--distance-static-l);\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (",
        ") {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}










var StyledContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-bab308ae-0"
})(_templateObject());
var StyledIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bab308ae-1"
})(_templateObject1());
var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Wrapper.Wrapper).withConfig({
    componentId: "sc-bab308ae-2"
})(_templateObject2());
var StyledIntroIdle = (0,styled_components_browser_esm/* default */.ZP)(Intro/* Intro */.p).withConfig({
    componentId: "sc-bab308ae-3"
})(_templateObject3());
var StyledIntro = (0,styled_components_browser_esm/* default */.ZP)(Intro/* Intro */.p).withConfig({
    componentId: "sc-bab308ae-4"
})(_templateObject4());
var IconCss = (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
var StyledProcessingIcon = (0,styled_components_browser_esm/* default */.ZP)(StatusScreen_styled/* StyledProcessingSVG */.w3).withConfig({
    componentId: "sc-bab308ae-5"
})(_templateObject6(), IconCss);
var StyledErrorIcon = (0,styled_components_browser_esm/* default */.ZP)(Error/* default */.Z).withConfig({
    componentId: "sc-bab308ae-6"
})(_templateObject7(), IconCss);
var StyledSuccessIcon = (0,styled_components_browser_esm/* default */.ZP)(Success/* default */.Z).withConfig({
    componentId: "sc-bab308ae-7"
})(_templateObject8(), IconCss);
var StyledHouse = (0,styled_components_browser_esm/* default */.ZP)(House/* default */.Z).withConfig({
    componentId: "sc-bab308ae-8"
})(_templateObject9());
var StyledForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-bab308ae-9"
})(_templateObject10(), mediaQueries/* tabletLandscape */.yJ, mediaQueries/* laptop */.PJ);
var StyledFieldset = styled_components_browser_esm/* default.fieldset.withConfig */.ZP.fieldset.withConfig({
    componentId: "sc-bab308ae-10"
})(_templateObject11(), function(param) {
    var $hasConsentError = param.$hasConsentError;
    return $hasConsentError ? "var(--distance-static-l)" : "var(--distance-static-m)";
}, mediaQueries/* tabletPortrait */.ZI);
var StyledResultButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-bab308ae-11"
})(_templateObject12());
var StyledAlert = (0,styled_components_browser_esm/* default */.ZP)(Alert/* Alert */.b).withConfig({
    componentId: "sc-bab308ae-12"
})(_templateObject13());
var StyledRichText = (0,styled_components_browser_esm/* default */.ZP)(RichText/* RichText */.H).withConfig({
    componentId: "sc-bab308ae-13"
})(_templateObject14(), mediaQueries/* laptop */.PJ, (0,gridCalc/* gridCalc */.T)(12));

;// CONCATENATED MODULE: ./src/components/modules/Newsletter/IdleState.tsx







var IdleState = function(param) {
    var onHandleSubmit = param.onHandleSubmit, idleLabels = param.idleLabels, validation = param.validation;
    var ref = (0,react.useState)({
        email: "",
        consentsDataProcessing: false
    }), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react.useState)(false), openGeneral = ref1[0], setOpenGeneral = ref1[1];
    var ref2 = (0,react.useState)(false), openConsent = ref2[0], setOpenConsent = ref2[1];
    (0,react.useEffect)(function() {
        var hasGeneralError = !!(validation.email && validation.consentsDataProcessing);
        setOpenGeneral(hasGeneralError);
        setOpenConsent(!hasGeneralError && !!validation.consentsDataProcessing);
    }, [
        validation
    ]);
    var selectHandle = function() {
        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
            consentsDataProcessing: !formData.consentsDataProcessing
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHouse, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntroIdle, {
                headline: {
                    label: idleLabels.headline,
                    size: "h3"
                },
                subtitle: idleLabels.title,
                copy: idleLabels.subHeadline,
                nested: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledForm, {
                onSubmit: function(e) {
                    return onHandleSubmit(e, formData);
                },
                children: [
                    openGeneral && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAlert, {
                        variant: "error",
                        onClose: function() {
                            return setOpenGeneral(false);
                        },
                        children: idleLabels.error.general
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFieldset, {
                        $hasConsentError: openConsent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* InputText */.o, {
                                placeholder: idleLabels.placeholder,
                                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Mail/* default */.Z, {}),
                                size: "m",
                                type: "email",
                                name: "newsletterEmail",
                                value: formData.email,
                                onChange: function(e) {
                                    return setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                        email: e.currentTarget.value
                                    }));
                                },
                                error: !!validation.email,
                                helperText: validation.email ? idleLabels.error.email : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                label: idleLabels.button,
                                variant: "secondary",
                                type: "submit"
                            })
                        ]
                    }),
                    openConsent && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAlert, {
                        variant: "error",
                        onClose: function() {
                            return setOpenConsent(false);
                        },
                        children: idleLabels.error.consent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                        name: "consentsDataProcessing",
                        onChange: selectHandle,
                        isRequired: true,
                        id: "consentsDataProcessing",
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableLabel/* ExpandableLabel */.L, {
                            isRequired: true,
                            maxLines: 3,
                            readMoreLabel: idleLabels.readMore,
                            readLessLabel: idleLabels.readLess,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRichText, {
                                content: idleLabels.consentText
                            })
                        }),
                        error: !!validation.consentsDataProcessing
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/utils/useFriendlyCaptcha.tsx + 1 modules
var useFriendlyCaptcha = __webpack_require__(1236);
;// CONCATENATED MODULE: ./src/components/modules/Newsletter/ResultState.tsx




var ResultStates = {
    processing: "processing",
    ok: "ok",
    error: "error",
    duplicate: "duplicate"
};
var ResultState = function(param) {
    var resultState = param.resultState, resultLabels = param.resultLabels, onHandleButtonError = param.onHandleButtonError, getSolutionHandler = param.getSolutionHandler;
    var ref = (0,useFriendlyCaptcha/* useFriendlyCaptcha */.H)(resultState === ResultStates.processing), FriendlyCaptchaComponent = ref.FriendlyCaptchaComponent, solution = ref.solution;
    var getIcon = function() {
        switch(resultState){
            case ResultStates.ok:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSuccessIcon, {});
            case ResultStates.error:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledErrorIcon, {});
            case ResultStates.duplicate:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProcessingIcon, {});
            case ResultStates.processing:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProcessingIcon, {});
        }
    };
    (0,react.useEffect)(function() {
        if (solution) {
            getSolutionHandler(solution);
        }
    }, [
        solution,
        getSolutionHandler
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconContainer, {
                children: getIcon()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntro, {
                headline: {
                    label: resultLabels[resultState].headline,
                    size: "h3"
                },
                subtitle: resultLabels.title,
                copy: resultLabels[resultState].subHeadline,
                nested: true
            }),
            resultState === ResultStates.processing && FriendlyCaptchaComponent,
            resultState === ResultStates.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledResultButton, {
                label: resultLabels.error.button,
                variant: "secondary",
                type: "button",
                onClick: onHandleButtonError
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/modules/Newsletter/subscribeNewsletterAPI.ts


var payloadEnrichment = function(requestData) {
    var ref;
    return {
        email: requestData.email,
        language: (ref = requestData.language) === null || ref === void 0 ? void 0 : ref.toUpperCase(),
        "privacy-checkbox-newsletter": requestData.consentsDataProcessing ? 1 : 0,
        "privacy-checkbox-default": requestData.consentsDataProcessing ? 1 : 0,
        node_id: requestData.nodeId
    };
};
var subscribeNewsletterAPI = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(requestData) {
        var NEWSLETTER_URL, NEWSLETTER_TOKEN, payload, options, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            NEWSLETTER_URL = "https://www.engelvoelkers.com/pubapi/newsletter/subscribe2";
            NEWSLETTER_TOKEN = "Basic ZXZkZXY6ZXZkZXY=";
            payload = payloadEnrichment(requestData);
            _tmp = {};
            options = (_tmp.method = "POST", _tmp.headers = {
                "Content-Type": "application/json",
                Authorization: "".concat(NEWSLETTER_TOKEN)
            }, _tmp.body = JSON.stringify(payload), _tmp);
            return [
                2,
                fetch("".concat(NEWSLETTER_URL), options)
            ];
        });
    });
    return function subscribeNewsletterAPI(requestData) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/modules/Newsletter/Newsletter.tsx
















var Newsletter = function(param) {
    var labels = param.labels, settings = param.settings;
    var ref = (0,react.useState)(), resultState = ref[0], setResultState = ref[1];
    var ref1 = (0,react.useState)({}), validation = ref1[0], setValidation = ref1[1];
    var ref2 = (0,react.useState)(""), solution = ref2[0], setSolution = ref2[1];
    var ref3 = (0,react.useState)(), formData = ref3[0], setFormData = ref3[1];
    var ref4 = (0,StoryProvider/* useStoryState */.d)(), storyState = ref4.state;
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath;
    var ref5 = (0,getSlugFromPath/* getSlugFromPath */.S)(asPath), _language = ref5.language, language = _language === void 0 ? "en" : _language;
    var validateFields = function(fieldType, value) {
        switch(fieldType){
            case "email":
                return typeof value === "string" && !isValidEmail(value);
            case "consentsDataProcessing":
                return !value;
        }
    };
    var onHandleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event, formData) {
            var data, _tmp, _tmp1, validation, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                event.preventDefault();
                _tmp = {};
                _tmp1 = {};
                data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, formData), (_tmp1.nodeId = settings.nodeId, _tmp1.language = language, _tmp1));
                _tmp2 = {};
                validation = Object.keys(formData).reduce(function(acc, key) {
                    var isValid = validateFields(key, formData[key]);
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, key, isValid));
                }, _tmp2);
                if (validation.email || validation.consentsDataProcessing) {
                    setValidation(validation);
                    return [
                        2
                    ];
                }
                setResultState(ResultStates.processing);
                setFormData(data);
                return [
                    2
                ];
            });
        });
        return function onHandleSubmit(event, formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var onHandleButtonError = function() {
        setResultState(null);
    };
    var getSolutionHandler = function(solution) {
        setSolution(solution);
    };
    (0,react.useEffect)(function() {
        if (!solution || !formData) return;
        (0,_async_to_generator/* default */.Z)(function() {
            var res, result, status, snowplow, _tmp, gtmEvent, e, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            subscribeNewsletterAPI(formData)
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.json()
                        ];
                    case 2:
                        result = _state.sent();
                        status = result.result.toLowerCase();
                        setResultState(status);
                        _tmp = {};
                        // on a successful response, send the lead event
                        if (status === ResultStates.ok) {
                            snowplow = (0,tracking_snowplow/* createSnowplow */.f3)(storyState.story, storyState.marketConfig);
                            snowplow.trackLead(constants/* trackingSource.newsletter */.MK.newsletter, (_tmp.email = formData.email, _tmp));
                            gtmEvent = (0,googleTagManager/* createGTMEvent */.X)(storyState.story, storyState.marketConfig);
                            gtmEvent.pushNewsletter();
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setResultState(ResultStates.error);
                        _tmp1 = {};
                        setValidation(_tmp1);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        solution,
        formData,
        storyState.story,
        storyState.marketConfig
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
            forwardedAs: "div",
            width: {
                laptop: "m",
                tabletLandscape: "s"
            },
            children: resultState ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultState, {
                resultState: resultState,
                getSolutionHandler: getSolutionHandler,
                resultLabels: labels.resultLabels,
                onHandleButtonError: onHandleButtonError
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IdleState, {
                onHandleSubmit: onHandleSubmit,
                idleLabels: labels.idleLabels,
                validation: validation
            })
        })
    });
};


/***/ })

}]);